import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEffectOnce } from 'react-use';
import { useTranslation } from 'next-i18next';
import { Input } from '@zep/ui/experimental';
import { RHFCheckboxGroup } from './RHFCehckboxGroup';
import { HardToUseFeature } from './schema';
export const HardToUseFeatures = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    resetField,
    register,
    watch
  } = useFormContext();
  const specificFunction = watch('hardToUseFeatures.specificFunction');
  const otherFeatures = watch('hardToUseFeatures.otherFeatures');
  useEffect(() => {
    if (!specificFunction) {
      resetField('hardToUseFeatures.specificFunctionReason');
    }
    if (!otherFeatures) {
      resetField('hardToUseFeatures.otherReason');
    }
  }, [specificFunction, otherFeatures, resetField]);
  useEffectOnce(() => {
    return () => {
      resetField('hardToUseFeatures');
    };
  });
  return <div className="flex flex-col gap-[8px]" data-sentry-component="HardToUseFeatures" data-sentry-source-file="HardToUseFeatures.tsx">
      <p className="text-body-2-m whitespace-pre text-wrap text-gray-600">
        {t('subscription:unsubscribe.8f66fed7', '무엇 때문에 사용이 어려우셨나요?')}
      </p>
      <RHFCheckboxGroup<HardToUseFeature> key={'hardToUseFeatures.makeMap'} name={'hardToUseFeatures.makeMap'} label={t('subscription:unsubscribe.e4f33d41', '맵 제작 및 수정이 어려워요')} data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="HardToUseFeatures.tsx" />
      <RHFCheckboxGroup<HardToUseFeature> key={'hardToUseFeatures.settingMap'} name={'hardToUseFeatures.settingMap'} label={t('subscription:unsubscribe.b2ce0f6b', '맵 세팅 (설정)을 하기 어려워요')} data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="HardToUseFeatures.tsx" />
      <RHFCheckboxGroup<HardToUseFeature> key={'hardToUseFeatures.operation'} name={'hardToUseFeatures.operation'} label={t('subscription:unsubscribe.2899176b', '운영이 어려워요')} data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="HardToUseFeatures.tsx" />
      <RHFCheckboxGroup<HardToUseFeature> key={'hardToUseFeatures.mobile'} name={'hardToUseFeatures.mobile'} label={t('subscription:unsubscribe.ee157766', '모바일에서 사용이 힘들어요')} data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="HardToUseFeatures.tsx" />
      <RHFCheckboxGroup<HardToUseFeature> key={'hardToUseFeatures.specificFunction'} name={'hardToUseFeatures.specificFunction'} label={t('subscription:unsubscribe.5460aeae', '특정 기능을 사용하기 어려워요')} description={t('subscription:unsubscribe.4e5b5129', '구체적으로 작성해 주시면 서비스 개선에 적극 반영하겠습니다.')} contentClassName="!mt-[8px] !py-0" data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="HardToUseFeatures.tsx">
        <Input placeholder={t('subscription:unsubscribe.a11dc72f', '사용이 어려우셨던 기능을 입력해 주세요 (필수)')} className="h-[40px] w-full" {...register('hardToUseFeatures.specificFunctionReason')} data-sentry-element="Input" data-sentry-source-file="HardToUseFeatures.tsx" />
      </RHFCheckboxGroup>
      <RHFCheckboxGroup<HardToUseFeature> key={'hardToUseFeatures.otherFeatures'} name={'hardToUseFeatures.otherFeatures'} label={t('subscription:unsubscribe.ca5582bc', '기타')} description={t('subscription:unsubscribe.4e5b5129', '구체적으로 작성해 주시면 서비스 개선에 적극 반영하겠습니다.')} contentClassName="!mt-[8px] !py-0" data-sentry-element="RHFCheckboxGroup" data-sentry-source-file="HardToUseFeatures.tsx">
        <Input placeholder={t('subscription:unsubscribe.a11dc72f', '사용이 어려우셨던 기능을 입력해 주세요 (필수)')} className="h-[40px] w-full" {...register('hardToUseFeatures.otherReason')} data-sentry-element="Input" data-sentry-source-file="HardToUseFeatures.tsx" />
      </RHFCheckboxGroup>
    </div>;
};